import { createTheme } from '@mui/material';

export default createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#118AE4',
        },
        success: {
            main: '#3AA716',
        },
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                html: {
                    height: '100%',
                    margin: 0,
                },
                body: {
                    minHeight: '100%',
                    margin: 0,
                },
            },
        },
        MuiTooltip: {
            defaultProps: {
                arrow: true,
            },
        },
    },
});